import { Http } from '@zhfe/common-library'
import { Injectable } from '@tanbo/vue-di-plugin'

export enum LogoffVerifyStatus {
  /** 成功 */
  Success = 'SUCCESS',
  /** 失败 */
  Failed = 'FAILED',
  /** 用户已经扫码，等待确认中 */
  Pending = 'SCANNED',
}

export interface OfficialLoginResponseData {
  /** 微信公众号注销二维码的URL */
  qrcode_url: string
  /** 用于检测用户是否验证成功 */
  verify_ticket: string
  /** 二维码有效时长,单位毫秒(超过时长不再轮询) */
  expire_seconds: number
}

export interface WxVerifyRequestParams {
  /** 用于通过注销登录校验 */
  verify_ticket: string
}

export interface WxVerifyResponseData {
  status: LogoffVerifyStatus
  /** 仅在 status 为 Success 时返回 */
  close_token?: string
  message?: string
}

@Injectable()
export class OfficialLogoffService {
  constructor(private http: Http) {
  }

  /**
   * @description 请求公众号注销登录二维码
   */
  requestOfficialQrcode () {
    return this.http.post<OfficialLoginResponseData>('/account/close/get_wx_verify_qrcode', {})
  }

  /**
   * @description 请求公众号是否通过注销登录校验
   */
  requestOfficialVerify (params: WxVerifyRequestParams) {
    return this.http.post<WxVerifyResponseData>('/account/close/confirm_wx_verify', params)
  }
}
